export const ACTION_UPLOAD_LIST_FILES = '/OsimMedia/UploadListFiles';

export const ACTION_SUBMIT_PRODUCT_REVIEW = '/ProductReviews/SubmitProductReview';

export const ACTION_GET_SERIAL_NUMBER_CHECKER = '/ProductReviews/OsimValidateSerialNumber';
